module.exports = __webpack_public_path__ + "static/media/WI4.bf2ed0db.jpg";